export default __webpack_public_path__ + "static/media/academic.9baf40d5.svg";